import { AppShell, Group, ThemeIcon } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { IconCalendar, IconCircles, IconFilter } from '@tabler/icons';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import PageHeader from '../../Templates/Navigation/PageHeader';
import { WindowContext } from '../../Service/Context/WindowContext';
import { ResourcesContextProvider } from '../../Service/Context/ResourcesContext';
import NavDrawer from '../../Atoms/NavDrawer';
import BookitupFooter from '../../Templates/Navigation/phone/BookitupFooter';
import ResourcesPageFooter from '../../Templates/Navigation/phone/ResourcesPageFooter';
import ResourcesNavBar from './ResourcesNavBar';
import BookitupTutorialIcon from '../../Atoms/BookitupTutorialIcon';
import AddResourceIcon from './AddResourceIcon';
import { openAvailabilityModal } from './ResourceModals';

const ResourcesPage = () => {
  const { sm } = useContext(WindowContext);
  const [drawerOpened, setDrawerOpened] = useState(false);

  useEffect(() => {
    document.title = 'Ressourcen';
  }, []);

  return (
    <ResourcesContextProvider>
      <AppShell
        header={<PageHeader />}
        navbar={
          sm ? undefined : (
            <DoubleNavbar>
              <ResourcesNavBar />
            </DoubleNavbar>
          )
        }
        styles={(theme) => ({
          main: { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'inherit', width: '100%' },
        })}
        footer={
          sm ? (
            <BookitupFooter>
              <ResourcesPageFooter filter={() => setDrawerOpened(true)} />
            </BookitupFooter>
          ) : undefined
        }
      >
        {sm && (
          <NavDrawer
            label="Ressourcen"
            icon={<IconCircles size={32} />}
            opened={drawerOpened}
            onClose={() => setDrawerOpened(false)}
          >
            <ResourcesNavBar />
          </NavDrawer>
        )}
        <Outlet />
      </AppShell>
    </ResourcesContextProvider>
  );
};

export default ResourcesPage;
